module.exports = __webpack_public_path__ + "static/media/IMG_20201012_234137_413.8e90de0a.jpg";